var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.501,
    height: 10.5
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warning_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#10181c",
    d: "M0 0h10.501v10.5H0z",
    "data-name": "Rectangle 577"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon - Warning"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#10181c",
    strokeWidth: 1.5,
    clipPath: "url(#warning_svg__a)",
    "data-name": "Group 1511"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.063a.281.281 0 110-.562",
    "data-name": "Path 4298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.063a.281.281 0 100-.562",
    "data-name": "Path 4299"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.25 5.813v-2.25",
    "data-name": "Line 552"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.61 7.824a1.315 1.315 0 01.139.655A1.329 1.329 0 018.42 9.75H2.081a1.328 1.328 0 01-1.132-.631 1.326 1.326 0 01-.058-1.3L4.06 1.486a1.331 1.331 0 012.381 0z",
    "data-name": "Path 4300"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMC41MDEiIGhlaWdodD0iMTAuNSI+Cgk8ZGVmcz4KCQk8Y2xpcFBhdGggaWQ9ImEiPgoJCQk8cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMxMDE4MWMiIGQ9Ik0wIDBoMTAuNTAxdjEwLjVIMHoiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDU3NyIgLz4KCQk8L2NsaXBQYXRoPgoJPC9kZWZzPgoJPGcgZGF0YS1uYW1lPSJJY29uIC0gV2FybmluZyI+CgkJPGcgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMTAxODFjIiBzdHJva2Utd2lkdGg9IjEuNSIgY2xpcC1wYXRoPSJ1cmwoI2EpIiBkYXRhLW5hbWU9Ikdyb3VwIDE1MTEiPgoJCQk8cGF0aCBkPSJNNS4yNSA4LjA2M2EuMjgxLjI4MSAwIDEgMSAwLS41NjIiIGRhdGEtbmFtZT0iUGF0aCA0Mjk4IiAvPgoJCQk8cGF0aCBkPSJNNS4yNSA4LjA2M2EuMjgxLjI4MSAwIDEgMCAwLS41NjIiIGRhdGEtbmFtZT0iUGF0aCA0Mjk5IiAvPgoJCQk8cGF0aCBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGQ9Ik01LjI1IDUuODEzdi0yLjI1IiBkYXRhLW5hbWU9IkxpbmUgNTUyIiAvPgoJCQk8cGF0aCBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGQ9Ik05LjYxIDcuODI0YTEuMzE1IDEuMzE1IDAgMCAxIC4xMzkuNjU1QTEuMzI5IDEuMzI5IDAgMCAxIDguNDIgOS43NUgyLjA4MWExLjMyOCAxLjMyOCAwIDAgMS0xLjEzMi0uNjMxIDEuMzI2IDEuMzI2IDAgMCAxLS4wNTgtMS4zTDQuMDYgMS40ODZhMS4zMzEgMS4zMzEgMCAwIDEgMi4zODEgMFoiIGRhdGEtbmFtZT0iUGF0aCA0MzAwIiAvPgoJCTwvZz4KCTwvZz4KPC9zdmc+Cg==";
export { SvgWarning as ReactComponent };